import React from 'react';
import { motion } from 'framer-motion';
import { Slide, itemVariants } from '../Slide';
export function SlideInsight() {
  return <Slide inverted className="justify-center items-center text-center" data-id="element-134">
      <motion.div variants={itemVariants} className="max-w-5xl" data-id="element-135">
        <h2 className="text-5xl md:text-7xl lg:text-[110px] font-serif leading-[1.1] tracking-tight" data-id="element-136">
          Every company is becoming an AI company.
          <br data-id="element-137" />
          <span className="italic text-gray-500" data-id="element-138">
            None of them have a brain for it.
          </span>
        </h2>
      </motion.div>
    </Slide>;
}